import instance from '../instance';

const getSelection = () => instance.driver.getSelection();

export default getSelection;
